import {Table} from 'antd'
import dayjs from 'dayjs'
import {Empty, Loader, ProfileCircleIcon} from 'common/components'
import {useGetStatements} from '..'
import { useStore, setStatementPageNumber as setPage } from '../store'
import { PAGE_SIZE } from '../constants'
// import styles from './Outlet.module.scss'
import { COLUMNS, /*ROWS*/ } from './mock.statements'
import { Pagination } from './Pagination'
export default function OutletStatements() {
  // const [count, setCount] = useState<number>(0)
  const page = useStore((state) => state.pageNumberStatement)
  const {data} = useGetStatements({ page })

  // const rowSelection = {
  //   onChange: (selectedRowKeys: React.Key[], selectedRows: StatementDataType[]) => {
  //     // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  //     setCount(selectedRowKeys?.length || 0)
  //   },
  // };

  // const rows = ROWS.filter(
  //   (_:any, index:number) => ( (1 + Math.floor(index/PAGE_SIZE)) === page)
  // )
  const rows = data?.data?.map((x:any, index:number) => ({
    key: x.uuid || index,
    date: dayjs(x.date).format('YYYY-MM-DD'),
    spent: (x.amount > 0) ? x.amount : undefined,
    received: (x.amount < 0) ? (-1 * x.amount) : undefined,
    description: x.description,
    client: x.project?.title,
    status: !x.transaction ? 'Unreconciled' : 'Reconciled',
  }))
  // console.log(data?.data)

  return (
    !data ? (
      <Loader />
    ) : !data.data?.length ? (
      <Empty
        icon={<ProfileCircleIcon width={40} height={40} />}
        title="users"
      />
    ) : (
    <>
      {/* <div className={styles.actions}>
        <Button className={styles.button}>Remove & Redo</Button>
        <span className={styles.count}>{count} selected</span>
      </div> */}

      <Table
        // rowSelection={{
        //   type: 'checkbox',
        //   ...rowSelection
        // }}
        columns={COLUMNS}
        dataSource={rows}
        pagination={false}
      />

      <Pagination
        showSizeChanger={false}
        current={page}
        total={data?.meta?.total}
        pageSize={PAGE_SIZE}
        onChange={setPage}
      />

    </>
    )
  )
}
